import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "telegram_svg__telegram" }, [
      _createElementVNode("path", {
        id: "telegram_svg__logo",
        d: "M2.10354 9.03177L12.8255 4.61412C13.8839 4.15395 17.4733 2.6814 17.4733 2.6814C17.4733 2.6814 19.1299 2.03716 18.9918 3.60174C18.9458 4.24598 18.5777 6.50082 18.2095 8.93973L17.0591 16.1644C17.0591 16.1644 16.9671 17.2228 16.1848 17.4069C15.4025 17.591 14.114 16.7626 13.8839 16.5786C13.6999 16.4405 10.4326 14.3698 9.23619 13.3574C8.91407 13.0813 8.54593 12.5291 9.28221 11.8848C10.9388 10.3663 12.9176 8.47956 14.114 7.28311C14.6662 6.73091 15.2184 5.44243 12.9176 7.00701L6.42914 11.3786C6.42914 11.3786 5.69287 11.8388 4.31235 11.4247C2.93184 11.0105 1.32124 10.4583 1.32124 10.4583C1.32124 10.4583 0.216836 9.76804 2.10354 9.03177Z",
        fill: "currentColor"
      })
    ], -1)
  ]))]))
}
export default { render: render }